<template>
  <v-container fluid>
    <template>
      <v-card class="my-4">
        <v-card-title>
          Integrations
          <v-spacer></v-spacer>
          <v-text-field
            v-model="searchIntegration"
            append-icon="fas fa-search"
            label="Pesquisa"
            single-line
            clearable
            hide-details
          ></v-text-field>
        </v-card-title>
        <v-data-table
          style="cursor: pointer;"
          :headers="[{ text: 'Nome', value: 'name' }]"
          :items="integrations"
          item-key="key"
          class="elevation-1"
          @click:row="addEditIntegration"
          :search="searchIntegration"
        ></v-data-table>
      </v-card>
    </template>
    <v-btn color="red" @click="fetchIntegrations()"
      ><v-icon class="mr-2">fas fa-sync</v-icon> Recarregar</v-btn
    >
    <v-btn color="warning" @click="$emit('close')"
      ><v-icon class="mr-2">fas fa-times</v-icon>Fechar</v-btn
    >
    <v-btn color="success" @click="saveIntegrations()"
      ><v-icon class="mr-2">fas fa-save</v-icon>Salvar</v-btn
    >
    <v-dialog
      v-model="dialogs.editIntegration"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <v-card>
        <v-toolbar dark color="primary">
          <v-btn icon dark @click="dialogs.editIntegration = false">
            <v-icon>fas fa-times</v-icon>
          </v-btn>
          <v-toolbar-title v-if="editIntegration && editIntegration.name"
            >Configuração de integração
            {{ editIntegration.name }}</v-toolbar-title
          >
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn dark text @click="saveIntegration()">Salvar</v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-container
          class="mx-2"
          v-if="
            editIntegration &&
              editIntegration.user_integrations &&
              editIntegration.type != 2
          "
        >
          <v-btn
            color="success"
            @click="editIntegration.user_integrations.push({})"
            >Add</v-btn
          >
          <v-row
            v-for="(_ui, ixUi) in editIntegration.user_integrations"
            :key="'userintegration_asd123' + ixUi + _ui.remove"
          >
            <v-col>
              <v-text-field
                :disabled="_ui.remove"
                clearable
                v-model="_ui.key"
                label="KEY"
              ></v-text-field>
            </v-col>
            <v-col v-if="editIntegration.type != 0">
              <v-text-field
                :disabled="_ui.remove"
                clearable
                v-model="_ui.login"
                label="Login"
              ></v-text-field>
            </v-col>
            <v-col v-if="editIntegration.type != 0">
              <v-text-field
                :disabled="_ui.remove"
                clearable
                v-model="_ui.password"
                label="Password"
              ></v-text-field>
            </v-col>
            <v-col>
              <v-text-field
                :disabled="_ui.remove"
                clearable
                v-model="_ui.value"
                label="Value"
              ></v-text-field>
            </v-col>
            <v-col class="text-right">
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-btn
                    v-if="!editIntegration.user_integrations[ixUi].id"
                    v-on="on"
                    color="orange"
                    @click="editIntegration.user_integrations.splice(ixUi, 1)"
                    ><v-icon>fas fa-minus</v-icon></v-btn
                  >
                  <v-btn
                    v-else-if="!editIntegration.user_integrations[ixUi].remove"
                    v-on="on"
                    color="red"
                    @click="
                      editIntegration.user_integrations[ixUi].remove = true
                    "
                    ><v-icon>fas fa-minus</v-icon></v-btn
                  >
                  <v-btn
                    v-else-if="editIntegration.user_integrations[ixUi].remove"
                    v-on="on"
                    color="green"
                    @click="
                      editIntegration.user_integrations[ixUi].remove = false
                    "
                    ><v-icon>fas fa-check</v-icon></v-btn
                  >
                </template>
                <span v-if="!_ui.remove">Remover regra</span>
                <span v-else>Voltar: cancela a remoção da regra</span>
              </v-tooltip>
            </v-col>
            <v-col v-if="_ui.remove" cols="12">
              <p class="ma-0 pa-0 red--text">Será removida ao salvar</p>
            </v-col>
          </v-row>
        </v-container>
        <v-container v-else>
          <p>Clique em autorizar somente quando necessário!</p>
          <v-btn color="error" @click="bitLyLogin()">Autorizar Bitly</v-btn>
          <v-row
            v-for="(_ui, ixUi) in editIntegration.user_integrations"
            :key="'userintegration_222' + ixUi + _ui.remove"
          >
            <v-col>
              <v-text-field
                disabled
                v-model="_ui.key"
                label="KEY"
              ></v-text-field>
            </v-col>
            <v-col v-if="editIntegration.type != 0">
              <v-text-field
                disabled
                v-model="_ui.login"
                label="Login"
              ></v-text-field>
            </v-col>
            <v-col v-if="editIntegration.type != 0">
              <v-text-field
                disabled
                v-model="_ui.password"
                label="Password"
              ></v-text-field>
            </v-col>
            <v-col>
              <v-text-field
                disabled
                v-model="_ui.value"
                label="Value"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-container>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
// @ is an alias to /src

export default {
  name: 'integrations',
  components: {},
  data() {
    return {
      editIntegration: {},
      searchIntegration: '',
      integrations: [],
      dialogs: {
        editIntegration: false
      }
    }
  },
  methods: {
    saveIntegrations() {
      var vm = this
      vm.$API
        .Request('put', 'integration/update', {
          data: JSON.stringify(vm.integrations)
        })
        .then(result => {
          console.debug(result.data)
          vm.fetchIntegrations().then(() => {
            vm.$snotify.success(`Integrações salvas com sucesso`)
            vm.$emit('saveIntegrations', vm.integrations)
          })
        })
        .catch(error => {
          vm.$snotify.error(`Erro ao salvar configurações: ${error.message}`)
          console.debug(error)
        })
    },
    saveIntegration() {
      var vm = this
      let _edit = false
      if (vm.integrations && !Array.isArray(vm.integrations)) {
        vm.integrations = []
      }
      vm.integrations.forEach(_i => {
        if (_i.key === vm.editIntegration.key) {
          _i = vm.editIntegration
          vm.$snotify.info(`Parametro editado com sucesso`)
          _edit = true
        }
      })
      if (!_edit) {
        vm.integrations.push(vm.editIntegration)
        vm.$snotify.success(`Novo parametro adicionado com sucesso`)
      }
      vm.editIntegration = {}
      vm.dialogs.editIntegration = false
    },
    addEditIntegration(_i) {
      var vm = this
      vm.editIntegration = _i
      vm.dialogs.editIntegration = true
    },
    fetchIntegrations() {
      var vm = this
      return new Promise((resolve, reject) => {
        vm.$API
          .Request('get', `integration/list`)
          .then(result => {
            if (result && result.data) {
              vm.integrations = result.data
            }
            console.debug(result)
            resolve(true)
          })
          .catch(error => {
            vm.$snotify.error(`Erro ao consultar integrações: ${error.message}`)
            console.debug(error)
            reject(error)
          })
      })
    },
    bitLyLogin() {
      var vm = this
      vm.$API
        .Request('put', 'integration/getBitlyLoginUrl', {})
        .then(result => {
          console.debug(result)
          if (result && result.data && result.data.url) {
            window.location.href = result.data.url
          } else {
            vm.$snotify.warning(
              `Houve algum problema ao recuperar a URL de login da plataforma Bitly`
            )
          }
        })
        .catch(error => {
          console.debug(error)
          vm.$snotify.error(`Oops... ${error.message}`)
        })
    }
  },
  created() {
    // Get all informations and update it
    var vm = this
    vm.fetchIntegrations()
  },
  mounted() {}
}
</script>
